//-------------------------------------------------------------------------------------------------- Imports
import { configureStore } from "@reduxjs/toolkit";
import generalDataSlice from "./slices/generalDataSlice";
import loadingSlice from "./slices/loadingSlice";
import bannersSlice from "./slices/bannersSlice";
import dueDateSlice from "./slices/dueDateSlice";
import alertSlice from "./slices/alertSlice";
import paymentDataSlice from "./slices/paymentDataSlice";
import bloquedDialogSlice from "./slices/bloquedDialogSlice";
import alertImageSlice from "./slices/alertImageSlice";
import mobilePhoneSlice from "./slices/mobilePhoneSlice";
import megamovilTrackingSlice from "./slices/megamovilTrackingSlice";
import updatePasswordSlice from "./slices/updatePasswordSlice";
import assetsConfigSlice from "./slices/assetsConfigSlice";
import countSlice from "./slices/countSlice";
import checkDebtSlice from "./slices/checkDebtSlice";
import alertConfirmationSlice from "./slices/alertConfirmationSlice";
import infoCardSlice from "./slices/infoCardSlice";
import statusConfirmationSlice from "./slices/statusConfirmationSlice";
import configurableServicesSlice from "./slices/configurableServicesSlice";
import myNetWorkSlice from "./slices/myNetworkSlice";

//-------------------------------------------------------------------------------------------------- Store
const store = configureStore({
    reducer: {
        generalData: generalDataSlice,
        mobilePhone: mobilePhoneSlice,
        megaMovil: megamovilTrackingSlice,
        assetsConfig: assetsConfigSlice,
        dueDate: dueDateSlice,
        paymentData: paymentDataSlice,
        loading: loadingSlice,
        count: countSlice,
        updatePassword: updatePasswordSlice,
        banners: bannersSlice,
        alert: alertSlice,
        alertImage: alertImageSlice,
        bloquedDialog: bloquedDialogSlice,
        checkDebtData: checkDebtSlice,
        alertConfirmation: alertConfirmationSlice,
        infoCard: infoCardSlice,
        statusConfirmation: statusConfirmationSlice,
        configurableService: configurableServicesSlice,
        myNetwork: myNetWorkSlice,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false})
});



//-------------------------------------------------------------------------------------------------- Exports
export default store;
export type AppDispatch = typeof store.dispatch;
